// removed by extract-text-webpack-plugin
module.exports = {"SideBar":"SideBar__SideBar__3YumA","Open":"SideBar__Open__3O-2x","Close":"SideBar__Close__29--3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navbar/SideBar/SideBar.css
// module id = 60
// module chunks = 0